import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ 
  title, 
  value, 
  change, 
  changeType, 
  icon, 
  trend, 
  period = "vs last month",
  onClick 
}) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div 
      onClick={onClick}
      className="bg-card rounded-xl border border-border p-6 shadow-elevation-1 hover:shadow-elevation-2 transition-gentle cursor-pointer group relative"
    >
      {/* Navigation indicator */}
      <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
        <Icon name="ArrowRight" size={16} className="text-primary" />
      </div>

      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name={icon} size={20} className="text-primary" />
          </div>
          <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
        </div>
        {trend && (
          <div className="w-16 h-8 bg-muted rounded flex items-center justify-center">
            <Icon name="BarChart3" size={14} className="text-muted-foreground" />
          </div>
        )}
      </div>
      
      <div className="space-y-2">
        <div className="text-2xl font-heading font-semibold text-foreground">
          {value}
        </div>
        {change && (
          <div className="flex items-center space-x-1">
            <Icon name={getChangeIcon()} size={14} className={getChangeColor()} />
            <span className={`text-sm font-medium ${getChangeColor()}`}>
              {change}
            </span>
            <span className="text-xs text-muted-foreground">{period}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricsCard;